import React, { useState, useEffect, useMemo } from "react";
import {
  makeStyles,
  Grid,
  Select,
  FormControl,
  InputBase,
  MenuItem,
  withStyles,
} from "@material-ui/core";
import { Pagination, PaginationItem } from "@material-ui/lab";
import { getPaginationPageNumber } from "../shared-resources/utils";

const useStyles = makeStyles(() => ({
  paginationSection: {
    marginTop: "4px",
  },
}));

export const PaginationData = ({
  data,
  setFilteredData,
  title,
  search,
  searchLcat,
  sortKey,
  sortDirection,
  alwaysShow,
}) => {
  const classes = useStyles();
  const searchedData = useMemo(() => {
    return data.filter((dt) => {
      const clinMatch = dt.clin?.toLowerCase().includes(search.toLowerCase());
      const lcatIdMatch = dt.lCatId
        ?.toLowerCase()
        .includes(searchLcat.toLowerCase());
      const descriptionMatch = dt.lCatDescription
        ?.toLowerCase()
        .includes(searchLcat.toLowerCase());

      const clinPass = search ? clinMatch : true;
      const lcatPass = searchLcat ? lcatIdMatch || descriptionMatch : true;

      return clinPass && lcatPass;
    });
  }, [data, search, searchLcat]);

  const [paginator, setPaginator] = useState({
    start: 0,
    end: 10,
    page: 1,
    limit: 10,
    count: searchedData.length / 10,
  });

  const limits = [5, 10, 15, 20, 25, searchedData.length];
  const handleChangeLimit = (event) => {
    const newLimit = parseInt(event.target.value, 10);

    setPaginator({
      start: 0,
      end: newLimit,
      page: 1,
      limit: newLimit,
      count: searchedData.length / +newLimit,
    });
  };

  const handleChangePage = (event, newPage) => {
    const start = (newPage - 1) * paginator.limit;
    const end = newPage * paginator.limit;
    setPaginator((prev) => ({ ...prev, page: newPage, start, end }));
  };

  useEffect(() => {
    setPaginator({
      ...paginator,
      count: searchedData.length / paginator.limit,
    });

    return () => {};
  }, [searchedData]);

  useEffect(() => {
  if (!Array.isArray(searchedData)) {
    return;
  }

  let _fData = searchedData;

  if (sortDirection && sortKey) {
    _fData = searchedData.sort((a, b) => {
      const aVal =
        sortKey === "margin" ? a[sortKey] : a[sortKey]?.toLowerCase?.() ?? "";
      const bVal =
        sortKey === "margin" ? b[sortKey] : b[sortKey]?.toLowerCase?.() ?? "";

      if (aVal < bVal) return sortDirection === "asc" ? -1 : 1;
      if (aVal > bVal) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }

  const paginatedWithOriginalIndex = _fData
    .slice(paginator.start, paginator.end)
    .map((item, index) => ({
      ...item,
      originalIndex: paginator.start + index,
    }));

  setFilteredData(paginatedWithOriginalIndex);

  return () => {};
}, [paginator, searchedData, sortKey, sortDirection]);

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  if (!alwaysShow && searchedData.length <= 10) return null;

  return (
    <div>
      <Grid container className={classes.paginationSection} spacing={0}>
        <Grid item lg={12}>
          <div style={{ float: "right", marginTop: "6px" }}>
            <Pagination
              count={Math.ceil(paginator.count)}
              showFirstButton
              showLastButton
              page={paginator.page}
              onChange={handleChangePage}
              color="primary"
              style={{ float: "right" }}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  page={getPaginationPageNumber(
                    item.page - 1,
                    searchedData.length,
                    paginator.limit
                  )}
                />
              )}
            />
          </div>
          <div style={{ float: "right", marginTop: "6px" }}>
            <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
            <FormControl className="tableRowsDdl">
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                value={paginator.limit}
                onChange={handleChangeLimit}
                input={<BootstrapInput />}
              >
                {limits.map((limit) => (
                  <MenuItem key={limit} value={limit}>
                    {limit}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
